import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('tooltips', [
      'getTooltipTextBySlug'
    ])
  }
}
